import { render, staticRenderFns } from "./loginChannelList.vue?vue&type=template&id=4a073bc6&scoped=true&"
import script from "./loginChannelList.vue?vue&type=script&lang=js&"
export * from "./loginChannelList.vue?vue&type=script&lang=js&"
import style0 from "./loginChannelList.vue?vue&type=style&index=0&id=4a073bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a073bc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a073bc6')) {
      api.createRecord('4a073bc6', component.options)
    } else {
      api.reload('4a073bc6', component.options)
    }
    module.hot.accept("./loginChannelList.vue?vue&type=template&id=4a073bc6&scoped=true&", function () {
      api.rerender('4a073bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gateway/loginChannelList.vue"
export default component.exports